export enum StatType {
  AllPosition,
  MyActivePos,
  MyCompletedPos,
  ViewAllBuyOrders,
}
